<template>
  <div class="container-fluid py-3 px-4">
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div v-if="idPerfil == 5" class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-wifi display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            TECNOLOGIA
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DECUENTO POR TECNOLOGIA
          </p>
        </div>
      </div>
    </div>

    
      <div v-if="idPerfil == 10" class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-gear-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            BIENESTAR
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DECUENTO POR BIENESTAR
          </p>
        </div>
      </div>


    <div v-if="idPerfil == 10" class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-gear-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            CONTABILIDAD
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DECUENTO POR CONTABILIDAD
          </p>
        </div>
      </div>

    <div v-if="idPerfil == 15" class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-gear-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            ALMACEN
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            DECUENTO POR ALMACEN
          </p>
        </div>
      </div>



    <div class="modal" v-if="showModal">
      <div class="modal-content">
        <div class="row">
          <div class="col-5">
            <select class="form-select w-100" aria-label="Default select example" @change="SelectorOptions($event)">
              <option selected>seleccionar</option>
              <option v-for="(items, index) in paramsTecnologia" :key="index.id" :value="index">
                {{ items.parDescripcion }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <p class="mb-1 mt-2" style="text-align: left">Monto a descontar:</p>
            <div class="d-flex">
              <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="" v-model="monto" />
              <button class="btn btn-success ms-2 " @click="GuardarInfo">Agregar</button>
            </div>
          </div>
        </div>

        <div class="mt-2 mx-1 table-responsive">
          <table v-if="primeraTabla" class="table table-bordered">
            <thead>
              <tr class="text-nowrap text-white bg-solimano">
                <th scope="col">ACCION</th>
                <th scope="col">ESTADO</th>
                <th scope="col">CIUDAD</th>

              </tr>
            </thead>
            <tbody>
              <tr class="text-nowrap" v-for="(itema, index) in Items.slice(0, 3)" :key="index.id">

                <td>
                  <select @change="Motivos($event)" v-if="itema.accionRen" class="form-control text-center"
                    id="exampleFormControlSelect1" required>
                    <option disabled selected>seleccionar motivo ...</option>
                    <option v-for="motivos in motivo" :key="motivos.id" :value="motivos.parCorrelativo">
                      {{ motivos.parDescripcion }}
                    </option>
                  </select>

                  <div class="" for="" v-else>
                    <p class="mb-0" v-if="itema.motivoRenovacion.length > 0">
                      {{ itema.motivoRenovacion }}
                    </p>
                    <p class="mb-0" v-else>-</p>
                  </div>
                </td>


                <td class="">{{ itema.diasTrabajador }}</td>


                <td class="py-0 my-0">
                  <div class="form-group">
                    <button :disabled="from.idRenovacion == itema.idRenovacion ||
                      itema.accionRen == true
                      ? false
                      : true
                      " @click="Registro(itema)" class="btn btn-light" type="submit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-check-circle text-success" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div  class="row gx-2 gy-2 mt-2">
          <div class="col-4" v-for="items in DescuentosPagar" :key="items.id">
            <div class="border border-1" style="height: 150px">{{ items.seleccionado }}

                {{ items.montos }}
            </div>
          </div>
        </div> -->

        <div class="row mt-2">
          <div class="col-1" @click="closeModal">
            <button class="btn btn-danger w-15">cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="card shadow-sm mb-3 border-3">

      <div class="d-flex justify-content-end mt-3 mx-2">
        <div
          class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm">
          <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
          <span class="fw-bold text-primary">
            Total de trabajadores : {{ Items.length }}
          </span>
        </div>
      </div>

      <div class="mt-2 mx-3 table-responsive">
        <table v-if="primeraTabla" class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">ACCION</th>
              <th scope="col">DOC. IDENTIDAD</th>
              <th scope="col">NOMBRE Y APELLIDOS</th>
              <th scope="col">PERIODO</th>
              <th scope="col">CC</th>
              <th scope="col">SCC</th>
              <th scope="col">SSCC</th>

            </tr>
          </thead>
          <tbody>
            <tr class="text-center align-middle reducirTamaño" v-for="(itema, index) in paginatedItems" :key="index.id">
              <th class="" scope="row">
                <div class="px-4">
                  <input @change="actualizarEstado(itema)" :disabled="isdisabled2" type="checkbox"
                    :value="itema.idRenovacion" v-model="itema.accionRen" />

                  <button @click="OpenModal(itema.idTrabajador)" class="btn btn-ligth border ms-2 px-2 pborder-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                      class="bi bi-cash-coin text-success" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z" />
                      <path
                        d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z" />
                      <path
                        d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z" />
                      <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z" />
                    </svg>
                  </button>
                </div>
              </th>

              <td>{{ itema.nroDocumento }}</td>
              <td>{{ itema.nomTrabajador }}</td>
              <td>{{ itema.periodo }}</td>
              <td>{{ itema.centroCostos }}</td>
              <td>{{ itema.subCentroCostos }}</td>
              <td>{{ itema.subSubCentroCostos }}</td>

            </tr>
          </tbody>
        </table>



        <div v-if="totalPages > 1"
          class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">
          <!-- Primera página -->
          <button class="btn btn-outline-primary btn-sm" @click="goToFirst" :disabled="currentPage === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <!-- Página anterior -->
          <button class="btn btn-outline-primary btn-sm" @click="prevPage" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

          <!-- Info -->
          <span class="pagination-info fw-semibold">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <!-- Página siguiente -->
          <button class="btn btn-outline-primary btn-sm" @click="nextPage" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>

          <!-- Última página -->
          <button class="btn btn-outline-primary btn-sm" @click="goToLast" :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>

      </div>
    </div>


    <!-- {{ checkeId }} -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
export default {
  name: 'SolimanologDescuentoTecnologia',

  data() {
    return {
      mensajeNumero: "",
      idRenovacion: "",
      checkeId: [],
      Dni: "",
      Apellidos: "",
      SubSubCentro: "",
      documentos: [],
      primeraTabla: true,
      segundaTabla: false,
      terceraTabla: false,
      excelCarga: false,
      excel: [],

      idTrabajador: "",

      from: {
        idRenovacion: "",
      },

      motivo: [],
      masisvo: [],
      CentroCosto: [],
      SubCentroCosto: [],
      SubSubCentroCosto: [],
      puesto: [],
      dniUsuario: "",
      idEmpresa: "",
      cenCodigoCentro: "",
      cenCodigoSubCentro: "",
      cenCodigoSubSubCemtro: "",
      codRenMotivo: "",
      fechaIni: "1900-01-01",
      fechaFin: "1900-01-01",
      idPuesto: "0",
      sueldo: 0,
      sueldoFinal: 0,
      sueldoCargo: 0,

      isdisabled: false,
      isdisabled2: false,

      currentPage: 1,
      perPage: 1,

      showModal: false,
      paramsTecnologia: [],
      DescuentosPagar: [],
      monto: "",
      parCodigo: "",
      parDescripcion: "",
      Items: [],
      idPerfil: ""

    };
  },

  mounted() {
    this.dniUsuario = localStorage.getItem("dniUsers");
    this.idTrabajador = localStorage.getItem("idTrabajdor");
    this.idPerfil = localStorage.getItem("idPerfil")


    this.axios.get("ParametroData/Parametro/7634").then((r) => {
      this.motivo = r.data;
    });

    this.axios.get("ParametroData/Parametro/2508").then((r) => {
      console.log(r.data);
      this.paramsTecnologia = r.data;
    });
    this.axios.get("PuestoData/ListadoPuesto").then((r) => {
      this.puesto = r.data;
    });

    console.log(this.Items.length);
    this.totalRows = this.Items.length;
  },

  computed: {
    ...mapGetters("users", ["DniEmpre"]),

    totalPages() {
      return Math.ceil(this.Items.length / this.perPage);
    },

    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.Items.slice(start, end);
    },
  },

  created() {
    this.OptionsUsers()
    this.cambiarEstadoNavbar()
  },

  methods: {
    ...mapActions("renovaciones", ["Renovaciones"]),
    // ...mapActions("renovaciones", ["RegistroCese"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    OptionsUsers() {
      this.axios.get(`Cese/ListarGestionCese/idTrabajador?idTrabajador=${localStorage.getItem("idTrabajdor")}`).then(r => {
        console.log(r.data)
        this.Items = r.data
      })
    },



    OpenModal(id) {
      this.showModal = true;
      this.$router.push(`/DescuentoTecnologiaParams/${id}/${this.idPerfil}`);
    },

    closeModal() {
      this.showModal = false;
    },

    SelectorOptions(event) {

      this.parCodigo = this.paramsTecnologia[event.target.value].parCodigo

      this.parDescripcion = this.paramsTecnologia[event.target.value].parDescripcion

      console.log(this.parCodigo, this.parDescripcion)
    },


    GuardarInfo() {

      console.log("olla")
      const from = {
        // id: `${this.contadorId}`,
        seleccionado: `${this.parDescripcion}`,
        montos: `${this.monto}`,
        parCodigo: `${this.parCodigo}`,

      }

      this.DescuentosPagar.push(from)
      this.contadorId++
      console.log(this.DescuentosPagar)
    },





    fetchItems() {
      console.log(this.Dni.length);

      if (this.Dni.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxDni?NroDocumento=${this.Dni}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }

            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchApellido() {
      console.log(this.Apellidos.length);

      if (this.Apellidos.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxApellido?Apellido=${this.Apellidos}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    fetchSubSubCentro() {
      this.documentos = [];
      if (this.SubSubCentro.length == 0) {
        this.primeraTabla = true;
        this.segundaTabla = false;
        this.documentos = [];
        this.Renovaciones();
      } else {
        this.axios
          .get(
            `Renovacion/BusquedaxSubSubCc?cuenta=${this.SubSubCentro}&idTrabajador=${this.idTrabajador}&codEstado=001`
          )
          .then((response) => {
            console.log(response.status);

            if (response.status) {
              this.primeraTabla = false;
              this.segundaTabla = false;
              this.terceraTabla = true;
              this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
              console.log(response.data);
            }
            this.documentos = response.data; // Actualizar los elementos filtrados con la respuesta de la API
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    CargaTrabajadores() {
      const usuario = localStorage.getItem("userId");
      this.axios
        .get(`Renovacion/CanTrabajadores?idUsuario=${usuario}`)
        .then((r) => {
          if (r.status == 200) {
            this.reporteRenovacion();
            if (r.data.canTrabajadores == "0") {
              Swal.fire(`No se cargo ningún trabajador`, "", "success");
            } else if (r.data.canTrabajadores == "1") {
              Swal.fire(
                `Se registro ${r.data.canTrabajadores}  trabajador`,
                "",
                "success"
              );
            } else {
              Swal.fire(
                `Se registraron ${r.data.canTrabajadores}  trabajadores`,
                "",
                "success"
              );
            }
          }

          this.Renovaciones();
        });
    },


    Motivos(event) {
      this.codRenMotivo = event.target.value;
    },

    SubSubCentroCostosManda(event) {
      this.cenCodigoSubSubCemtro = event.target.value;
      console.log(event.target.value);
    },

    Puesto(index) {
      const puestos = this.puesto[index - 1];
      this.idPuesto = puestos.idPuesto;
      this.sueldoCargo = puestos.rangoSueldo;

      console.log(puestos);
    },

    FechaIni(event) {
      this.fechaIni = event.target.value;
      console.log(event.target.value);
    },

    FechaFin(event) {
      this.fechaFin = event.target.value;
    },
    Registro(items) {
      console.log(items);

      if (this.fechaIni == "1900-01-01" && this.fechaFin == "1900-01-01") {
        const form = {
          idRenovacion: items.idRenovacion,
          idrenResponsable: this.idTrabajador,
          renCodCC: items.renCodCC,
          renCodScc: items.renCodScc,
          renCodSscc: this.cenCodigoSubSubCemtro,
          idPuestoNuevo: this.idPuesto,
          renSueldo: this.sueldoFinal,
          codRenMotivo: this.codRenMotivo,
          fechaIniContrato: items.fechaIniContrato,
          fechaFinContrato: items.fechaFinContrato,
        };

        console.log(form);

        if (this.sueldoFinal < items.renSueldoActual) {
          Swal.fire({
            icon: "error",
            title: "El sueldo no puede ser menor al sueldo actual",
            text: "",
          });
        } else {
          this.axios
            .put("Renovacion/ModificarRenovacion", form)
            .then((r) => {
              console.log(r.data);
              if (r.data == true) {
                this.isdisabled2 = false;
                this.primeraTabla = true;
                this.segundaTabla = false;
                this.terceraTabla = false;
                this.Renovaciones();
                Swal.fire("Se registró renovación", "", "success");
              }
            })
            .catch((error) => {
              console.log(error.response.status);
              if (error.response.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: "Falto  el motivo de la renovación",
                  text: "",
                });
              }
            });
        }
      } else {
        const form = {
          idRenovacion: items.idRenovacion,
          idrenResponsable: this.idTrabajador,

          renCodCC: items.renCodCC,
          renCodScc: items.renCodScc,
          renCodSscc: this.cenCodigoSubSubCemtro,
          idPuestoNuevo: this.idPuesto,
          renSueldo: this.sueldoFinal,
          codRenMotivo: this.codRenMotivo,
          fechaIniContrato: items.fechaIniContrato.slice(0, 10),
          fechaFinContrato: this.fechaFin,
        };
        console.log(form);

        if (this.sueldoFinal < items.renSueldoActual) {
          Swal.fire({
            icon: "error",
            title: "El sueldo no puede ser menor al sueldo actual",
            text: "",
          });
        } else {
          this.axios
            .put("Renovacion/ModificarRenovacion", form)
            .then((r) => {
              console.log(r.data);
              if (r.data == true) {
                this.isdisabled2 = false;
                this.Renovaciones();
                Swal.fire("Se registró renovación", "", "success");
              }
            })
            .catch((error) => {
              console.log(error.response.status);
              if (error.response.status == 400) {
                Swal.fire({
                  icon: "error",
                  title: "Falto  el motivo de la renovación",
                  text: "",
                });
              }
            });
        }
      }
    },

    actualizarEstado(items) {
      console.log(items);
      this.from.idRenovacion = items.idRenovacion;

      for (let index of this.Items) {
        if (index.idRenovacion == items.idRenovacion) {
          console.log(index.idEmpresa, index.renCodCC, index.renCodScc);
          this.axios
            .get(
              `SubSubCentro/SScxTrabajador?idEmpresa=${index.idEmpresa}&dniUser=${this.dniUsuario}&codCentro=${index.renCodCC}&codSubCentro=${index.renCodScc}`
            )
            .then((r) => {
              this.SubSubCentroCosto = r.data;
              console.log(r.data);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }

      if (items.accionRen == true) {
        this.isdisabled2 = true;
        this.colorRenovacion = items.idRenovacion;
      } else {
        this.colorRenovacion = "";
      }

      this.axios.put("Renovacion/ModificarAccionxRen", this.from).then((r) => {
        console.log(r);
      });
    },

    goToFirst() {
      this.currentPage = 1;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToLast() {
      this.currentPage = this.totalPages;
    },

  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  /* Fondo más transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: auto;
  /* Permite eventos de ratón en el modal */
}

.modal-content {
  width: 70%;
  height: auto;
  background-color: #fbfbfb;
  border: 3px rgb(60, 60, 60) solid;
  padding: 0.5%;
}

select {
  margin-top: 0px;
  padding: 0px;
}

input[type="date"] {
  padding: 0px;
  height: auto;
}

input[type="text"] {
  min-width: 150px;
  padding: 0px;
}

.text-left {
  text-align: left;
}

select {
  width: auto;
  display: inline-block;

  text-align: center;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

.texto-color {
  color: #002c5d;
  font-size: 2.155rem;
  font-weight: 700;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.oscuro {
  font-weight: 700;
}

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.bg-solimano {
  background: #1565C0;
}

.tamaño {
  font-size: 0.8rem;
}

.btn-solimano {
  background: #0080c8;
}
</style>
